export const state = () => ({
  watchList: [],
  loading: {
    watch: false
  },
  ttl: 1800000
})

export const mutations = {
  set_data (state, { stateName, childState = null, data }) {
    if (childState) {
      state[stateName][childState] = data
    } else {
      state[stateName] = data
    }
  },
  set_centrifuge (state, { index, data }) {
    state.watchList[index].price = Number(data)
  },
  add_watchList (state, payload) {
    state.watchList.push(payload)
  },
  remove_watchList (state, payload) {
    const index = state.watchList.findIndex(i => i.symbol === payload)
    state.watchList.splice(index, 1)
  }
}

export const actions = {
  addFavorite ({ commit, dispatch, state }, payload) {
    commit('add_watchList', payload)
    dispatch('axios/post', { url: '/watchList/add', data: { account: 'arzypto_otc', symbol: payload.symbol }, config: { baseURL: process.env.BASE_URL_UUID } }, { root: true })
      .then(() => {
        dispatch('setWithExpiry', { key: 'watchList', value: state.watchList, ttl: 15000 })
      }).catch(() => {
      })
  },
  removeFavorite ({ commit, dispatch, state }, payload) {
    commit('remove_watchList', payload.symbol)
    dispatch('axios/put', { url: '/watchList/remove', data: { account: 'arzypto_otc', symbol: payload.symbol }, config: { baseURL: process.env.BASE_URL_UUID } }, { root: true })
      .then(() => {
        dispatch('setWithExpiry', { key: 'watchList', value: state.watchList, ttl: 15000 })
      }).catch(() => {
      })
  },
  setWithExpiry (_, { key, value, ttl }) {
    const now = new Date()
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value,
      expiry: now.getTime() + ttl
    }
    window.localStorage.setItem(key, JSON.stringify(item))
  },
  getWithExpiry ({ dispatch, commit }, key) {
    const itemStr = window.localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      window.localStorage.removeItem(key)
      dispatch('getWatchList')
    } else {
      commit('set_data', {
        stateName: 'watchList',
        data: item.value
      })
    }
  },
  getWatchList ({ commit, dispatch, state }) {
    commit('set_data', { stateName: 'loading', childState: 'watch', data: true })
    dispatch('axios/get', { url: '/watchList', config: { baseURL: process.env.BASE_URL_UUID } }, { root: true })
      .then(async (res) => {
        await dispatch('axios/get', {
          url: window.location.origin + '/fapi/coinsFilter',
          config: { params: { symbols: res.data.data.map(i => i.symbol).toString() } }
        }, { root: true })
          .then((resp) => {
            dispatch('setWithExpiry', { key: 'watchList', value: resp.data.data, ttl: state.ttl })
            commit('set_data', {
              stateName: 'watchList',
              data: resp.data.data
            })
          })
        commit('set_data', { stateName: 'loading', childState: 'watch', data: false })
      })
      .catch(() => {
        commit('set_data', { stateName: 'loading', childState: 'watch', data: false })
      })
  }
}

export const getters = {
  watchList (state) {
    return state.watchList
  }
}
